<template>    
    <div>
        <v-app-bar dense flat color="#323234" app white>
            <v-toolbar-title class="d-flex">
                <v-img class="d-flex" :src="require('@/assets/Logo.png')"/>
            </v-toolbar-title>            
            <v-toolbar-title class="white--text d-flex" v-if="isAdmin()">{{ $t($store.state.locale) }}</v-toolbar-title>            
            <v-spacer></v-spacer>
            <v-app-bar-nav-icon color="#49a5ac" @click="drawer = true"></v-app-bar-nav-icon>            
        </v-app-bar>
        <v-navigation-drawer v-model="drawer" fixed temporary right>
            <v-list nav dense rounded>                
                <v-list-item v-if="$store.state.qlikUrl" to="/dashboards"><v-list-item-icon><v-icon>mdi-chart-bar</v-icon></v-list-item-icon><v-list-item-title>{{$t("dashboards")}}</v-list-item-title></v-list-item>
                <v-list-item to="/pzns"><v-list-item-icon><v-icon>mdi-test-tube</v-icon></v-list-item-icon><v-list-item-title>{{$t("pzns")}}</v-list-item-title></v-list-item>
                <v-list-item to="/keywords"><v-list-item-icon><v-icon>mdi-file-document-edit-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("keywords")}}</v-list-item-title></v-list-item>
                <v-list-item to="/amazonsearch"><v-list-item-icon><v-icon>mdi-cart-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("keywords amazon")}}</v-list-item-title></v-list-item>
                <v-list-item to="/websearch"><v-list-item-icon><v-icon>mdi-cloud-search-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("keywords google")}}</v-list-item-title></v-list-item>                
                <v-list-item to="/zalandokeywords"><v-list-item-icon><v-icon>mdi-shoe-sneaker</v-icon></v-list-item-icon><v-list-item-title>{{$t("keywords zalando")}}</v-list-item-title></v-list-item>                
                <v-list-item to="/amazoncategories"><v-list-item-icon><v-icon>mdi-store-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("categories amazon")}}</v-list-item-title></v-list-item>                
                <v-list-item to="/zalandocategories"><v-list-item-icon><v-icon>mdi-shoe-heel</v-icon></v-list-item-icon><v-list-item-title>{{$t("categories zalando")}}</v-list-item-title></v-list-item>                
                <v-list-item to="/files"><v-list-item-icon><v-icon>mdi-file-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("files")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/customers"><v-list-item-icon><v-icon>mdi-domain</v-icon></v-list-item-icon><v-list-item-title>{{$t("customers")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/users"><v-list-item-icon><v-icon>mdi-account-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("users")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/pharmacies"><v-list-item-icon><v-icon>mdi-bank-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("pharmacies")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/scraper"><v-list-item-icon><v-icon>mdi-spider</v-icon></v-list-item-icon><v-list-item-title>{{$t("jobs")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/pzndetails"><v-list-item-icon><v-icon>mdi-text-box-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("pzn details")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/advertising"><v-list-item-icon><v-icon>mdi-cash-100</v-icon></v-list-item-icon><v-list-item-title>{{$t("advertising")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/categoryads"><v-list-item-icon><v-icon>mdi-cash-check</v-icon></v-list-item-icon><v-list-item-title>{{$t("category advertising")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/settings"><v-list-item-icon><v-icon>mdi-cog-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("settings")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/sessions"><v-list-item-icon><v-icon>mdi-chart-bell-curve</v-icon></v-list-item-icon><v-list-item-title>{{$t("sessions")}}</v-list-item-title></v-list-item>
                <v-list-item v-if="isAdmin()" to="/pzncheck"><v-list-item-icon><v-icon>mdi-alert-circle-check-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("verify pzn")}}</v-list-item-title></v-list-item>
                <v-list-item to="/currentpzns"><v-list-item-icon><v-icon>mdi-alert</v-icon></v-list-item-icon><v-list-item-title>{{$t("current pzns")}}</v-list-item-title></v-list-item>
                <v-divider></v-divider>
                <v-list-item @click="changePassword"><v-list-item-icon><v-icon>mdi-account-key-outline</v-icon></v-list-item-icon><v-list-item-title>{{$t("modify password")}}</v-list-item-title></v-list-item>
                <v-list-item @click="logoutClicked"><v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon><v-list-item-title>{{$t("logout")}}</v-list-item-title></v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>

import { Utils } from "@/Utils"
import Api from "@/Api";

export default
{
    mixins: [Utils],

    data()
    {
        return {
            drawer: false,
        }
    },

    methods:
    {
        logoutClicked()
        {
            Api.logout();
            this.$store.state.name = "";
        },
        changePassword()
        {
            if (this.$router.currentRoute.path !== "/password")
                this.$router.push("/password");
        }
    }
}

</script>

<style>
.v-tab
{
    text-transform: none !important;
}

.v-tabs i.mdi-chevron-right, .v-tabs i.mdi-chevron-left
{
    color: white !important;
}

</style>